"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const statisticItemFields = (0, graphql_tag_1.default)`
  fragment statisticItemFields on PetitionStatisticItem {
    amount
    area
    percent
  }
`;
const petitionStatistics = (0, graphql_tag_1.default)`
  ${statisticItemFields}
  query petitions_petition_statistic($petitionId: Int!) {
    petitions {
      petition {
        statistic(petitionId: $petitionId) {
          signed {
            ...statisticItemFields
          }
          refused {
            ...statisticItemFields
          }
          abstained {
            ...statisticItemFields
          }
          notViewed {
            ...statisticItemFields
          }
          revoked {
            ...statisticItemFields
          }
        }
      }
    }
  }
`;
exports.default = petitionStatistics;